import React from "react";
import { cn, getStatusStyle } from "../../lib/utils";

export const StatusBadge = ({ status, className }) => {
  const style = getStatusStyle(status);
  
  return (
    <span
      className={cn(
        "status-badge border",
        style.bg,
        style.text,
        style.border,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {style.label}
    </span>
  );
};

export default StatusBadge;
